// With the Tuning Results column defs were changed, we need to blow away that table's preferences
import PrefsService from "../services/PrefsService"

export default function migration5 () {
    PrefsService.delete('alarmsFilter-nm-alarms-radio-details')
}